import { driver_state } from './driver_state';

/**
 * Balance is derived directly from the driver profile.
 *
 * The driver store subscribes to `drivers_stream`, so `computed_balance` and
 * `computed_monthly_earnings` stay in sync automatically. When we need a fresh
 * pull, `fetch_balance()` just refreshes the driver row (the subscription then
 * converges the UI).
 */
export const balance_state = {
	balance: {
		get value(): number {
			return driver_state.value?.computed_balance ?? 0;
		}
	},

	monthly_earnings: {
		get value(): number {
			return driver_state.value?.computed_monthly_earnings ?? 0;
		}
	},

	init: () => {},

	fetch_balance: async (): Promise<
		{ success: true; data: { computed_balance: number; monthly_earnings: number } } | { success: false; data: null }
	> => {
		try {
			// H3: authoritative-refresh — read the returned row, not the view.
			// The view can lag (live-query re-emission is async), which made the
			// old `populate()`-then-read-view pattern racy.
			// `refresh()` returns the single driver row (not an array).
			const driver = await driver_state.refresh();
			if (!driver) return { success: false, data: null };

			const computed_balance = driver.computed_balance ?? 0;
			const monthly_earnings = driver.computed_monthly_earnings ?? 0;
			return { success: true, data: { computed_balance, monthly_earnings } };
		} catch (error) {
			console.error('error at balance.ts fetch_balance fn', error);
			return { success: false, data: null };
		}
	}
};
